const getLastDayOfMonth = (monthIndex, year = 0) => {
  const fullYear = year || new Date().getFullYear()

  return new Date(fullYear, monthIndex + 1, 0)
}

export default getLastDayOfMonth
